const TAGS = ["88吃瓜", "88吃瓜复盘", "88大结局", "88吃瓜总结", "88收尾讨论", "事件全程回顾"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20collage%20about%20viral%20gossip%20review%20and%20detective%20drama%2C%20warm%20cream%20paper%20background%20with%20coral%20red%20and%20amber%20gold%20geometric%20shapes%2C%20floating%20chat%20bubbles%2C%20film%20clapper%20board%2C%20popcorn%2C%20magnifying%20glass%2C%20camera%20lens%2C%20red%20thread%20evidence%20board%2C%20magazine%20collage%20aesthetic%2C%20soft%20organic%20composition%2C%20energetic%20yet%20harmonious%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=melon-hero-2026&orientation=landscape"
          alt="88吃瓜复盘站的暖色调编辑部插画背景，包含对话框、场记板与线索板元素"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-900/45 to-background-950/75" aria-hidden="true" />
      </div>

      <div className="relative">
        <div className="page-shell flex w-full flex-col items-center py-16 text-center md:py-24">
          <p className="inline-flex items-center gap-2 rounded-full border border-background-200/40 bg-background-50/10 px-4 py-1.5 text-xs font-semibold tracking-wide text-background-100 backdrop-blur-sm">
            <i className="ri-megaphone-line text-accent-400" aria-hidden="true" />
            吃瓜编辑部 · 第 88 期大结局专题
          </p>

          <h1 className="mt-6 max-w-4xl font-display text-5xl leading-[1.05] text-background-50 md:text-7xl">
            88吃瓜<span className="text-accent-400">复盘</span>站
          </h1>

          <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
            起因、经过、高潮、转折、大结局到收尾讨论，<br className="hidden sm:block" />
            一条线帮你把整件事彻底捋清楚。错过了全程？现在补课刚刚好。
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <a
              href="#timeline"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
            >
              <i className="ri-play-circle-line text-lg" aria-hidden="true" />
              从头开始复盘
            </a>
            <a
              href="#finale"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200/60 bg-background-50/10 px-6 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
            >
              <i className="ri-flag-2-line text-lg text-accent-400" aria-hidden="true" />
              直接看大结局
            </a>
            <a
              href="#overview"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full px-4 py-3 text-sm font-medium text-background-200 underline-offset-4 hover:underline"
            >
              先看全程导读
              <i className="ri-arrow-down-line" aria-hidden="true" />
            </a>
          </div>

          <ul className="mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-2" aria-label="热门关键词">
            {TAGS.map((tag) => (
              <li key={tag}>
                <a
                  href="#overview"
                  className="inline-flex items-center whitespace-nowrap rounded-full border border-background-200/30 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur-sm transition-colors hover:bg-accent-500/90 hover:text-foreground-950"
                >
                  # {tag}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}